import React from 'react'
import { useNavigate } from 'react-router'
import { useUploadSoldReportsForDealership } from '../../../../api/dealership/customers/useUploadSoldReportsForDealership'
import { useCreateCustomersFTPUploadSource } from '../../../../api/dealership/customers/sources/useCreateCustomersFTPUploadSource'
import { useGetSaasSoldReportsColumns } from '../../../../api/dealership/customers/util/useGetSaasSoldReportsColumns'
import { Button } from '@demandlocal/components'
import { ReactComponent as IconClose } from './../../../../images/icons/icon_close.svg'
import SourcePickerFTP from '../../SourcePicker/FTP'
import SourcePickerManualUpload from '../../SourcePicker/ManualUpload'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import { useTranslation } from 'react-i18next'

const UnspecifiedCustomers = (): JSX.Element => {
  const navigate = useNavigate()
  const manualUploadCSVMutation = useUploadSoldReportsForDealership()
  const ftpUploadCSVMutation = useCreateCustomersFTPUploadSource()
  const { data: databaseColumns } = useGetSaasSoldReportsColumns()
  const dealership = useDealership()
  const { t } = useTranslation('routes')

  return (
    <div className={'flex flex-1 flex-col px-12 pt-5 font-Spartan h-full overflow-auto'}>
      <div className={'flex flex-1 flex-col'}>
        <div className={'flex justify-between items-center'}>
          <span className={'font-bold text-[28px] text-primary-xiketic'}>
            Import your customers
          </span>
          <IconClose
            className={'cursor-pointer'}
            onClick={(e) => {
              navigate(t('dealership.customers.sources.list', { dealership }))
            }}
          />
        </div>
        <div className={'mt-24 font-bold text-base'}>Upload your data</div>
        <div className={'grid grid-cols-2 justify-between mt-7 gap-5'}>
          <SourcePickerManualUpload
            manualUploadCSVMutation={manualUploadCSVMutation}
            databaseColumns={databaseColumns}
            selectedUploadType={'other'}
          />
          <SourcePickerFTP
            ftpUploadCSVMutation={ftpUploadCSVMutation}
            databaseColumns={databaseColumns}
          />
        </div>
      </div>
      <div className={'flex justify-start py-5 border-t'}>
        <Button
          variant={'tertiary'}
          onClick={(e) => {
            e.preventDefault()
            navigate(-1)
          }}>
          Back
        </Button>
      </div>
    </div>
  )
}

export default UnspecifiedCustomers
